function BlockView() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinejoin="round" aria-hidden>
            <path d="M9 2H3C1.9 2 1 2.9 1 4V9C1 10.1 1.9 11 3 11H9C10.1 11 11 10.1 11 9V4C11 2.9 10.1 2 9 2Z" />
            <path d="M21 2H15C13.9 2 13 2.9 13 4V9C13 10.1 13.9 11 15 11H21C22.1 11 23 10.1 23 9V4C23 2.9 22.1 2 21 2Z" />
            <path d="M9 13H3C1.9 13 1 13.9 1 15V20C1 21.1 1.9 22 3 22H9C10.1 22 11 21.1 11 20V15C11 13.9 10.1 13 9 13Z" />
            <path d="M21 13H15C13.9 13 13 13.9 13 15V20C13 21.1 13.9 22 15 22H21C22.1 22 23 21.1 23 20V15C23 13.9 22.1 13 21 13Z" />
        </svg>
    );
}

export default BlockView;
